// Header.tsx
'use client';

import { Button } from '@/components/ui/Button/Button';
import useDevice from '@/hooks/useDevice';
import "@/styles/sections/sections.scss";
import { useRouter } from 'next/navigation';
import { useLanguage } from '@/context/LanguageContext';
import Image from 'next/image';

const BottomCta = () => {
    const router = useRouter();
    const { t } = useLanguage();
    return (
        <div className="bottom-cta-section">

            <div className='logo-container'>
                <Image src="/CodiMe-symbol-logotype-2.png" alt="logo" width={90} height={24} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>

            <div className='headline'>
                <p className='title'>
                    {t.bottomCta.title}
                </p>
                <p className='subtitle'>
                    {t.bottomCta.subtitle}
                </p>
            </div>
            <div className='button-container'>
                <Button
                    type='white'
                    size='large'
                    icon='none'
                    otherClassName='btn-radius-100'
                    label={t.bottomCta.viewIntro}
                    onClick={() => { window.open('https://public.relate.so/p/docs/gvzlq85v3aqtlt8a', '_blank') }}
                />
                <Button
                    type='primary2'
                    size='large'
                    icon='right'
                    iconName='icon-arrow_right'
                    iconColor='white'
                    otherClassName='btn-radius-100'
                    label={t.bottomCta.contactUs}
                    onClick={() => window.open('https://public.relate.so/p/forms/pzst8jlmfdxtahcw', '_blank')}
                />
            </div>

        </div>
    );
};

export default BottomCta;